<ng-container>
  <nav class="topnav navbar navbar-expand shadow navbar-light bg-white px-3">
    <a class="navbar-brand" [routerLink]="route">
      <img style="height: 40px" src="https://dkmzd4tgwtjws.cloudfront.net/public/images/logos/plasma_logo_h.png" alt="Plasma Games logo" />
    </a>
    <div class="container-fluid">
      <ul class="navbar-nav align-items-center ms-auto">
        <sbpro-top-nav-user tourAnchor="user-icon"></sbpro-top-nav-user>
      </ul>
    </div>
  </nav>
</ng-container>
